module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA/BAMAAADkhXBTAAAAFVBMVEUAaaegpz7LuSEAaqe+tCr+zADuxgv90OhxAAAAA3RSTlO/4+9xkiI1AAAARElEQVR4AWNkQAWMiiDy/30G3IDReIhrGdUyqmVUy6gWF1Q+Ez9Y9B0+LaHYxUe1jGohKY0N4yw2qmVUy6iWUS1k9CwAzX5z/z9HWkYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/se.png
// module id = 5d4S
// module chunks = 0